import { useEffect } from 'react';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import {
    StatisticsContent,
    StatisticsDynamicPricingContent,
} from '@starjack/entities/statistics';
import { Permission } from '@/models/user';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { SyntheticEvent, useState } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Tab } from '@mui/material';
import { Environment } from '@starjack/entities/environment';
import { useTranslation } from 'react-i18next';
import { PageWithLayout } from '@/models/page';
import { useGetB2BUsersQuery } from '@starjack/entities/b2b';

const Page: PageWithLayout = () => {
    const [value, setValue] = useState('1');
    const { t } = useTranslation();
    const { data: b2bUsersData } = useGetB2BUsersQuery();
    const b2bUsers = (b2bUsersData?.b2bUsers ?? []).map((u) => ({
        id: u.id,
        name: u.name,
    }));

    const [selectedEnvironments, setSelectedEnvironments] = useState<
        Environment[]
    >([
        Environment.PORTAL,
        Environment.INTEGRATION,
        Environment.HOSPITALITY,
        Environment.B2B,
    ]);

    const handleCheckboxChange = (event: SyntheticEvent) => {
        const { value, checked } = event.target as HTMLInputElement;

        if (checked) {
            setSelectedEnvironments((prev) => [...prev, value as Environment]);
        } else {
            setSelectedEnvironments((prev) =>
                prev.filter((type) => type !== value)
            );
        }
    };

    const handleChange = (_, newValue: string) => {
        setValue(newValue);
    };

    useEffect(() => {
        document.title = 'Dashboard | Starjack Admin';
    }, []);

    return (
        <TabContext value={value}>
            <FormGroup
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 2,
                }}
            >
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleCheckboxChange}
                            value={Environment.PORTAL}
                            defaultChecked
                        />
                    }
                    label='Starjack Portal'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleCheckboxChange}
                            value={Environment.INTEGRATION}
                            defaultChecked
                        />
                    }
                    label='Webshop'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleCheckboxChange}
                            value={Environment.HOSPITALITY}
                            defaultChecked
                        />
                    }
                    label='Hospitality'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleCheckboxChange}
                            value={Environment.B2B}
                            defaultChecked
                        />
                    }
                    label='B2B'
                />
            </FormGroup>

            <TabList
                sx={{
                    mb: 4,
                    borderBottom: 1,
                    borderColor: 'divider',
                }}
                onChange={handleChange}
            >
                <Tab label={t('generalSalesStatistics')} value='1' />
                <Tab label={t('salesStatisticsByOffer')} value='2' />
            </TabList>

            <TabPanel value='1'>
                <StatisticsContent
                    environment={selectedEnvironments}
                    b2bUsers={b2bUsers}
                />
            </TabPanel>

            <TabPanel value='2'>
                <StatisticsDynamicPricingContent
                    environments={selectedEnvironments}
                    b2bUsers={b2bUsers}
                />
            </TabPanel>
        </TabContext>
    );
};

Page.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Page.isProtected = true;
Page.permissions = [Permission.STATISTIC_NAV];

export default Page;
